import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import {
  ComparatorBuilder,
  DataContextBuilder,
  IDataContext,
  Sort,
  SortUtil,
  ViewProviders,
  ElderTableComponent,
  ElderNumberCellDirective,
  ElderQuantityPipe,
} from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { PackageGroup } from '../storage-group'
import { Package, PackageLocation } from '../../packages/package'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'

import { MatIcon } from '@angular/material/icon'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-package-group-table',
  templateUrl: './package-group-table.component.html',
  styleUrls: ['./package-group-table.component.scss'],
  viewProviders: [ViewProviders.ParentControlContainer],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderNumberCellDirective,
    ElderTranslatePipe,
    ElderQuantityPipe,
  ],
})
export class PackageGroupTableComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _packageGroups$ = new BehaviorSubject<PackageGroup[]>([])

  public data: IDataContext<PackageGroup>

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get packageGroups$(): Observable<PackageGroup[]> {
    return this._packageGroups$.asObservable()
  }

  public get packageGroups(): PackageGroup[] {
    return this._packageGroups$.getValue()
  }

  @Input()
  public set packageGroups(groups: PackageGroup[]) {
    if (groups) {
      this.data = DataContextBuilder.start<PackageGroup>()
        .localSort((data, sorts) => SortUtil.sortData(data, sorts))
        .buildLocal(groups, 'id')

      this.data.start([new Sort('baseLocation', 'asc')])
    }
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
